<template>
<div>
  <div class="imgbanner-container">
    <img src="/assets/mainbanner-background.jpg"/>
    <div class="img-caption">


    </div>
  </div>
</div>
</template>